(function () {
  "use strict";

  var ONLINE_ONLY_TAGS = ["hash-online-only", "online-only"];
  var FEATURED_TAGS = ["featured", "hash-featured"];

  function getContentApiConfig() {
    var configScript = document.querySelector("script[data-key][data-api]");

    if (!configScript) {
      return null;
    }

    return {
      api: configScript.getAttribute("data-api"),
      key: configScript.getAttribute("data-key"),
    };
  }

  function getCardSlug(card) {
    var link = card.querySelector(".rbi-title a, .rbi-media[href]");

    if (!link) {
      return "";
    }

    var parts = new URL(link.href, window.location.origin).pathname
      .split("/")
      .filter(Boolean);

    return parts[parts.length - 1] || "";
  }

  function initialiseIssueCardInteractions() {
    var grid = document.getElementById("rbi-grid");

    if (!grid || grid.dataset.cardInteractions === "ready") {
      return;
    }

    grid.dataset.cardInteractions = "ready";

    function getCardLink(card) {
      return (
        card.querySelector(".rbi-title a") ||
        card.querySelector(".rbi-media[href]")
      );
    }

    function prepareCards() {
      grid.querySelectorAll(".rbi-card").forEach(function (card) {
        var link = getCardLink(card);

        if (!link) {
          return;
        }

        card.setAttribute("role", "link");
        card.setAttribute("tabindex", "0");
        card.setAttribute("aria-label", link.textContent.trim() || "Open article");
      });
    }

    grid.addEventListener("click", function (event) {
      var card = event.target.closest(".rbi-card");

      if (
        !card ||
        event.defaultPrevented ||
        event.button !== 0 ||
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.altKey ||
        event.target.closest("a, button, input, select, textarea")
      ) {
        return;
      }

      var link = getCardLink(card);
      if (link) {
        window.location.assign(link.href);
      }
    });

    grid.addEventListener("keydown", function (event) {
      var card = event.target.closest(".rbi-card");

      if (!card || event.target !== card || event.key !== "Enter") {
        return;
      }

      var link = getCardLink(card);
      if (link) {
        event.preventDefault();
        window.location.assign(link.href);
      }
    });

    prepareCards();
    new MutationObserver(prepareCards).observe(grid, {
      childList: true,
      subtree: true,
    });
  }

  function markCards(grid, onlineOnlySlugs) {
    grid.querySelectorAll(".rbi-card").forEach(function (card) {
      if (!onlineOnlySlugs.has(getCardSlug(card))) {
        return;
      }

      card.classList.add("rb-online-only-card");

      if (card.querySelector(".rb-online-only-label")) {
        return;
      }

      var label = document.createElement("span");
      var media = card.querySelector(".rbi-media");
      var title = card.querySelector(".rbi-title");

      label.className = "rb-online-only-label";
      label.textContent = "Online only";

      if (media) {
        media.insertAdjacentElement("afterend", label);
      } else if (title) {
        card.insertBefore(label, title);
      }
    });
  }

  function getPostPosition(post) {
    var position = Infinity;

    (post.tags || []).some(function (tag) {
      var slugMatch = (tag.slug || "").match(/^(?:hash-)?pos-(\d+)$/);
      var nameMatch = (tag.name || "").match(/^#pos-(\d+)$/i);
      var match = slugMatch || nameMatch;

      if (!match) {
        return false;
      }

      position = parseInt(match[1], 10);
      return true;
    });

    return position;
  }

  function orderCards(grid, positionBySlug, defaultOrderBySlug) {
    var cards = Array.prototype.slice.call(grid.querySelectorAll(".rbi-card"));
    var defaultCards = cards.slice().sort(function (a, b) {
      var aSlug = getCardSlug(a);
      var bSlug = getCardSlug(b);
      var aIndex = defaultOrderBySlug.has(aSlug)
        ? defaultOrderBySlug.get(aSlug)
        : Infinity;
      var bIndex = defaultOrderBySlug.has(bSlug)
        ? defaultOrderBySlug.get(bSlug)
        : Infinity;

      return aIndex - bIndex;
    });
    var slots = new Array(cards.length);
    var defaultQueue = [];

    defaultCards.forEach(function (card) {
      var slug = getCardSlug(card);
      var position = positionBySlug.has(slug)
        ? positionBySlug.get(slug)
        : Infinity;
      var slotIndex = position - 1;

      // A #pos-N tag pins only that exact slot. Every other slot is filled by
      // unpinned posts in Ghost's default published_at order.
      if (
        Number.isFinite(position) &&
        position >= 1 &&
        slotIndex < slots.length &&
        !slots[slotIndex]
      ) {
        slots[slotIndex] = card;
      } else {
        defaultQueue.push(card);
      }
    });

    var queueIndex = 0;
    var orderedCards = [];

    for (var slot = 0; slot < slots.length; slot += 1) {
      if (slots[slot]) {
        orderedCards.push(slots[slot]);
      } else {
        orderedCards.push(defaultQueue[queueIndex]);
        queueIndex += 1;
      }
    }

    var orderChanged = orderedCards.some(function (card, index) {
      return card !== cards[index];
    });

    if (!orderChanged) {
      return;
    }

    orderedCards.forEach(function (card) {
      grid.appendChild(card);
    });
  }

  function initialiseOnlineOnlyCards() {
    var grid = document.getElementById("rbi-grid");
    var config = getContentApiConfig();

    if (!grid || !config || !config.api || !config.key) {
      return;
    }

    var endpoint = new URL("posts/", config.api);
    endpoint.searchParams.set("key", config.key);
    endpoint.searchParams.set("limit", "all");
    endpoint.searchParams.set("include", "tags");

    /* The Home template wraps fetch so its issue grid always requests
       #featured posts. Bypass that wrapper for this metadata request: it needs
       every post in order to resolve Online only and #pos-N correctly. */
    var metadataFetch = window.rbOriginalFetch || window.fetch;

    metadataFetch.call(window, endpoint.toString())
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Ghost Content API returned " + response.status);
        }

        return response.json();
      })
      .then(function (data) {
        var posts = data.posts || [];
        var featuredSlugs = new Set(
          posts
            .filter(function (post) {
              return (post.tags || []).some(function (tag) {
                return FEATURED_TAGS.indexOf(tag.slug) !== -1;
              });
            })
            .map(function (post) {
              return post.slug;
            }),
        );
        var onlineOnlySlugs = new Set(
          posts
            .filter(function (post) {
              return (post.tags || []).some(function (tag) {
                return ONLINE_ONLY_TAGS.indexOf(tag.slug) !== -1;
              });
            })
            .map(function (post) {
              return post.slug;
            }),
        );
        var positionBySlug = new Map(
          posts.map(function (post) {
            return [post.slug, getPostPosition(post)];
          }),
        );
        var defaultOrderBySlug = new Map(
          posts.map(function (post, index) {
            return [post.slug, index];
          }),
        );

        function syncCards() {
          grid.querySelectorAll(".rbi-card").forEach(function (card) {
            var slug = getCardSlug(card);

            if (slug && !featuredSlugs.has(slug)) {
              card.remove();
            }
          });

          markCards(grid, onlineOnlySlugs);
          orderCards(grid, positionBySlug, defaultOrderBySlug);
        }

        syncCards();

        new MutationObserver(function () {
          syncCards();
        }).observe(grid, { childList: true, subtree: true });
      })
      .catch(function (error) {
        console.warn("Rubicon online-only cards could not be marked.", error);
      });
  }

  function initialiseHomepageEnhancements() {
    initialiseIssueCardInteractions();
    initialiseOnlineOnlyCards();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialiseHomepageEnhancements);
  } else {
    initialiseHomepageEnhancements();
  }
})();
